import { useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useDispatch, useSelector } from "react-redux";
import { filterAgendamento } from "../../store/modules/agendamentos/saga";
import agendamentos from "../../store/modules/agendamentos/reducer";
import hourToMinutes from "../../utils";

const localizer = momentLocalizer(moment);

const Agendamentos = () => {
  const dispatch = useDispatch();

  const { agendamentos } = useSelector((state) => state.agendamento);

  const formatEventos = agendamentos.map((agendamento) => ({
    title: `${agendamento.title} `,
    start: moment(agendamento.data).toDate(),
    end: moment(agendamento.data)
      .add(
        hourToMinutes(moment(agendamento.id.duracao).format("HH:mm")),
        "minutes"
      )
      .toDate(),
  }));

  const formatRange = (periodo) => {
    let finalRange = {};
    if (Array.isArray(periodo)) {
      finalRange = {
        start: moment(periodo[0]).format("YYYY-MM-DD"),
        end: moment(periodo[periodo.length - 1]).format("YYYY-MM-DD"),
      };
    }else{
      finalRange = {
        start: moment(periodo.start).format("YYYY-MM-DD"),
        end: moment(periodo.end).format("YYYY-MM-DD"),
      };
    }

    return finalRange
  };

  useEffect(() => {
    // dispatch(
    //   filterAgendamento(
    //   moment().weekday(0).format("YYYY-mm-DD")/*start*/,
    //  moment().weekday(6).format("YYYY-mm-DD")/*end*/
    // )
    // );
  }, []);

  //[{title: "evento teste", start: moment().toDate(), end: moment().add(30,'minutes').toDate()},]
  return (
    <div className="col p-5 h-100 overflow-auto">
      <div className="row">
        <div className="col-12">
          <h2 className="mb-4 mt-0">Agendamentos</h2>
          <Calendar
            localizer={localizer}
            onRangeChange={(periodo) => {
            const {start, end} = formatRange(periodo)
            dispatch(
              filterAgendamento(start, end)
            )
            }}
            events={[
              {
                title: "evento teste",
                start: moment().toDate(),
                end: moment().add(30, "minutes").toDate(),
              },
            ]}
            defaultView="week"
            selectable
            popup
            style={{ height: 600 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Agendamentos;
